// extracted by mini-css-extract-plugin
module.exports = {"hidden":"inputFactory_hidden__vjtHy","default-style":"inputFactory_default-style__2Yepe"};